import { render, staticRenderFns } from "./SynonymPage.vue?vue&type=template&id=261cdfb8"
import script from "./SynonymPage.vue?vue&type=script&lang=js"
export * from "./SynonymPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports